import { useCallback, useEffect, useState } from 'react';
import { UpdatesSettings } from '@integrations/watchpod/react';
import { Select } from '../../components/Select';
import { api } from '../../lib/api';
import type { UpdatePrefs, UpdatesView } from '../../lib/api';
import { updateActions, updatesUi } from '../../lib/integrations';
import { useStore } from '../../store/StoreProvider';

// Impostazioni › Aggiornamenti: il collegamento a WatchPOD e le due preferenze. La scheda è
// quella del pacchetto condiviso, uguale in tutte le app di casa (note della versione comprese);
// qui restano colori e select.
export function UpdatesTab() {
  const { toast } = useStore();
  const [overview, setOverview] = useState<UpdatesView | null>(null);
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setOverview(await api.updates());
    } catch {
      // controllare gli aggiornamenti non deve mai disturbare chi lavora
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const savePrefs = async (patch: Partial<UpdatePrefs>) => {
    if (!overview) return;
    setBusy(true);
    setOverview({ ...overview, ...patch });
    try {
      setOverview(await api.saveUpdatePrefs(patch));
    } catch {
      toast({ kind: 'danger', title: 'Preferenze non salvate', body: 'Riprova fra poco.' });
      await refresh();
    } finally {
      setBusy(false);
    }
  };

  return (
    <UpdatesSettings
      ui={updatesUi}
      overview={overview}
      actions={updateActions}
      busy={busy}
      onSavePrefs={savePrefs}
      renderSelect={({ value, options, onChange }) => (
        <Select
          value={String(value)}
          label="Frequenza dei controlli"
          width={170}
          options={options.map((o) => ({ value: String(o.value), label: o.label }))}
          onChange={(v) => onChange(Number(v))}
        />
      )}
      onSaveToken={async (token) => setOverview(await api.saveWatchpodToken(token))}
      onSaveUrl={async (url) => setOverview(await api.saveWatchpodUrl(url))}
      onRetry={async () => setOverview(await api.retryWatchpod())}
      onRefresh={refresh}
      changelog={__APP_CHANGELOG__}
      appVersion={__APP_VERSION__}
    />
  );
}
